import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvServiceBookingList.html?raw';
import on from 'dojo/on';
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import '../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { VAM2types, VAMclassNames } from "../../_loadingHelpers/VAMv2Types";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { DateHelpers, DOMhelpers, EntityHelpers, FeatureHelpers, HtmlHelpers, StringHelpers, TranslationHelpers } from "../../../more/Helpers";
import EvService_ResourceLoadTable from '../../EvService/Resources/ResourceLoadTable';
import { EvService_ResourceLoadCheck, EvService_ResourceLoadCheckRequestData } from "../../EvService/Resources/ResourceLoadCheck";
import EvServiceConfigPanel from './EvServiceConfigPanel/EvServiceConfigPanel';

interface resourceTableRegistryEntry { table: MdsLax<InstanceType<typeof EvService_ResourceLoadTable>>, isOverload: boolean };

class EvServiceBookingList extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
	templateString: any = template;
    private inputEvService: MdsLax<InstanceType<typeof HintBox>>;

    sectionAddEntry: HTMLElement;

    private evBooking: VAM2types.EvBooking_Base;
    private reloadContainer: HTMLElement;

    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable<VAM2types.EvServiceBooking>>>;
    private store: MdsLax<InstanceType<typeof EntityStore<VAM2types.EvServiceBooking>>>;
    private entitylist: Array<any>;

    private canceledServiceContainer: HTMLDivElement;
    private canceledServiceTable: MdsLax<InstanceType<typeof StaticTable>>;
    private canceledServiceStore: MdsLax<InstanceType<typeof EntityStore<VAM2types.EvServiceBooking>>>

    private optionCheckBoxRegistry: {} = { };
    private canceledCheckBoxRegistry: {} = { };


    private roomId: string = null;

    private tableLayout: StaticTable.RowConfig = {
        attributes: ["description", "$service_type", "is_option", "quantity_text", "price_total_pricelist"],
        colNamesInternal: ["description", "service_type", "is_option", "quantity_text", "price_total_pricelist"],
        colspans: [1, 1, 1, 1, 1],
        headings: ["General_Description", "General_Label_Type", "General_Label_Option", "General_Label_Quantity", "General_Label_Price"],
        widths: [null, null, "16ch", "25ch", "10ch"],
        alignmentsHeading: [null, null, null, null, "right"],
        alignmentsRow: [null, null, null, null, "right"]
    };

    private canceledServiceBookingsTableLayout: StaticTable.RowConfig = {
        attributes: ["description", "$service_type", "quantity_text", "price_total_pricelist"],
        colNamesInternal: ["description", "service_type", "quantity_text", "price_total_pricelist"],
        colspans: [1, 1, 1, 1],
        headings: ["General_Description", "General_Label_Type", "General_Label_Quantity", "General_Label_Price"],
        widths: [null, "16ch", "25ch", "10ch"],
        alignmentsHeading: [null, null, null, "right"],
        alignmentsRow: [null, null, null, "right"]
    };



    private table_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.EvServiceBooking>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        //this.UiModder.domClass.toggle(node, "w3-text-red", !entity.ref_performer);

        switch (colName) {
            case "is_finished":
                if (value) {
                    this.disableNode(cell.tableRow.node);
                    this.UiModder.domClass.add(cell.tableRow.node, "w3-opacity");
                }
                break;
            case "quantity_text":

                if (entity.is_cancelled) {
                    this.disableNode(cell.tableRow.node);
                    this.UiModder.domClass.add(cell.tableRow.node, "cancelled w3-opacity strike");
                }

                // Hinweis: das Attribut quantity_text gibts nicht. Das wird in LEGACY schon direkt im JS zusammengebaut. Hier also auch:
                if (entity.service_type === VAM2types.EvServiceType.default) {

                    let unitStr = "";
                    if (entity.unitCode) this.stringFormat("× {0}{1}", entity.quantity, entity.unitCode ? " " + entity.unitCode : "")
                    if (entity.quantity == 1 && !!entity.unitCode) unitStr = this.stringFormat("{0}", entity.unitCode)

                    let numberInput = new NumberInput();
                    let row = this.UiModder.domConstruct.create("div", { "class": "flex_row nowrap flex_gapSmall" }, node);
                    let inputCol = this.UiModder.domConstruct.create("div", { "class": "w3-col m9" }, row);
                    let unitCol = this.UiModder.domConstruct.create("div", { "class": "w3-col m3 flex_col justify_center" }, row);

                    numberInput.setRange(1, 9999);
                    numberInput.setValue(entity.quantity_multiplier, true);
                    numberInput.placeAt(inputCol);

                    let unitLabel = this.UiModder.domConstruct.create("span", {}, unitCol);
                    unitLabel.innerHTML = unitStr;

                    //numberInput.setUnit(unitStr);

                    numberInput.setReadonly(!this.hasUserRole("Service_Edit"));

                    on(numberInput, "change", lang.hitch(this, this._onChange_ServiceQuantity, entity));
                } else if (entity.service_type == VAM2types.EvServiceType.yesno) {
                    node.innerHTML = ""; // TranslationHelpers.tryTranslate("EvServiceBookingList_YesNoQuestionmark");
                    let container = this.UiModder.domConstruct.create("div", { class: "flex_row_center justify_center" }, node);
                    switch (entity.is_yes_no_questionmark_1) {
                        case "Y":
                            HtmlHelpers.createFontawesomeIcon("fas fa-check-circle", "left", container, "last");
                            break;
                        case "N":
                            HtmlHelpers.createFontawesomeIcon("fas fa-times-circle", "left", container, "last");
                            break;
                        case "?":
                            HtmlHelpers.createFontawesomeIcon("fas fa-question-circle", "right", container, "last");
                            break;
                        default:
                            if (entity?.ID) {
                                node.innerHTML = " - invalid value! - ";
                            } else {
                                node.innerHTML = "";
                                this.disableNode(node);
                            }
                            break;
                    }

                } else {

                    node.innerHTML = "";// entity.$service_type;
                    //this.disableNode(cell.tableCellNode, true);
                }

                if (!entity.is_cancelled && FeatureHelpers.hasFeature("EvService/PhysicalResources")) {

                    if (entity.EL_resource_booking_1_vt_pos_ev_serv?.length) {
                        for (let booking of entity.EL_resource_booking_1_vt_pos_ev_serv) {
                            if (booking.warning_level_res_booking >= 3) {
                                this.table.setCellClick(lang.hitch(this, this._onClick_Cell), "quantity_text");
                                this.UiModder.domClass.add(cell.tableCellNode, "warningRed");
                                if (entity.service_type != VAM2types.EvServiceType.default && entity.service_type != VAM2types.EvServiceType.yesno) {
                                    cell.value = this.translate("ServiceBookingList_PhysicalRource_Overbooked");
                                    node.innerHTML = this.translate("ServiceBookingList_PhysicalRource_Overbooked");
                                }
                                //let span = this.UiModder.domConstruct.create("p", { className: "w3-right"}, node);
                                //DOMhelpers.createFontawesomeIcon("fas fa-chair", null, span);
                                //DOMhelpers.createFontawesomeIcon("fas fa-exclamation-triangle", null, span);

                                break;
                            }
                        }
                    }

                }
                return true;

            case "price_total_pricelist":
            case "price_total_after_disc":
                if (entity.service_type === VAM2types.EvServiceType.default) {
                    if (this.store.isEntityNew(entity)) {
                        node.innerHTML = "<i>" + this.translate("EvBookingditor_ToCalculate") + "</i>";
                    }
                    else {
                        if (typeof (value) == "string" && value != "") {
                            node.innerHTML = parseFloat(value).toFixed(2) + " €";
                            return true;
                        } else if (typeof (value) == "number") {
                            node.innerHTML = value.toFixed(2) + " €";
                            return true;
                        } else if ((!entity.ref_pricelist && !entity.is_oversteered_price) || true) {
                            cell.value = this.translate("ServiceList_Warning_NoPricelist");
                            node.innerHTML = cell.value;
                            this.UiModder.domClass.add(cell.tableCellNode, "warningTXT warningRed");
                            return true;
                        }
                        return false;
                    }
                } else {

                    node.innerHTML = "";// entity.$service_type;
                    //this.disableNode(cell.tableCellNode, true);
                }
                return true;
                break;
            case "is_option":
                if (entity.service_type != VAM2types.EvServiceType.default) {
                    //this.disableNode(cell.tableCellNode, true);
                    node.innerHTML = "";
                    return true;
                } else {              

                    let checkBox = this.optionCheckBoxRegistry[entity.ID];
                    if (!checkBox) {
                        checkBox = new CheckBox();
                        checkBox.setValue(entity.is_option, true);
                        if (!entity.is_finished && !entity.is_cancelled && this.hasUserRole("Service_Edit")) {
                            checkBox.on("change", lang.hitch(this, this._onChangeOption, entity));
                        } else {
                            this.disableNode(checkBox, true);
                        }
                        this.optionCheckBoxRegistry[entity.ID] = checkBox;
                    }
                    node.innerHTML = "";
                    checkBox.placeAt(node);
                    return true;
                }
                break;
            case "discount":
                if (entity.service_type === VAM2types.EvServiceType.default) {
                    node.innerHTML = `${value ? value : 0} %`;
                } else {
                    node.innerHTML = "";
                    //this.disableNode(cell.tableCellNode, true);
                }
                return true;
                break;
        }

        /*


         **/


        return false;
    }

    private _onChangeOption(entity: VAM2types.EvServiceBooking, value: boolean) {
        let entityCopy = lang.clone(entity);
        entityCopy.is_option = value;
        this.store.changeEntry(entityCopy, true);
    }
    private _onChangeCanceled(entity: VAM2types.EvServiceBooking, value: boolean) {
        let entityCopy = lang.clone(entity);
        entityCopy.is_cancelled = value;
        this.canceledServiceStore.changeEntry(entityCopy, true);
    }



    private canceledServiceBookingsTable_formatterFunction(cell: StaticTable.StaticTableCell<VAM2types.EvServiceBooking>): boolean {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        //this.UiModder.domClass.toggle(node, "w3-text-red", !entity.ref_performer);

        switch (colName) {
            case "is_finished":
                if (value) {
                    this.disableNode(cell.tableRow.node);
                    this.UiModder.domClass.add(cell.tableRow.node, "w3-opacity");
                }
                return false;
            case "quantity_text":

                if (entity.is_cancelled) {
                    this.UiModder.domClass.add(cell.tableRow.node, "cancelled strike");
                }

                // Hinweis: das Attribut quantity_text gibts nicht. Das wird in LEGACY schon direkt im JS zusammengebaut. Hier also auch:
                if (entity.service_type === VAM2types.EvServiceType.default) {

                    let valueStr = "";
                    let unitStr = "";
                    if (entity.quantity_multiplier) valueStr = this.stringFormat("{2} × {0}{1}", entity.quantity, entity.unitCode ? " " + entity.unitCode : "", entity.quantity_multiplier);
                    else valueStr = this.stringFormat("{0}{1}", entity.quantity, entity.unitCode ? " " + entity.unitCode : ""); 
                    node.innerHTML = valueStr;


                } else if (entity.service_type == VAM2types.EvServiceType.yesno) {
                    node.innerHTML = ""; // TranslationHelpers.tryTranslate("EvServiceBookingList_YesNoQuestionmark");
                    let container = this.UiModder.domConstruct.create("div", { class: "flex_row_center justify_center" }, node);
                    switch (entity.is_yes_no_questionmark_1) {
                        case "Y":
                            HtmlHelpers.createFontawesomeIcon("fas fa-check-circle", "left", container);
                            break;
                        case "N":
                            HtmlHelpers.createFontawesomeIcon("fas fa-times-circle", "left", container);
                            break;
                        case "?":
                            HtmlHelpers.createFontawesomeIcon("fas fa-question-circle", "left", container);
                            break;
                        default:
                            if (entity?.ID) {
                                node.innerHTML = " - invalid value! - ";
                            } else {
                                node.innerHTML = "";
                                //this.disableNode(cell.tableCellNode);
                            }
                            break;
                    }

                } else {

                    node.innerHTML = "";// entity.$service_type;
                    //this.disableNode(cell.tableCellNode, true);
                }
                return true;
            case "price_total_pricelist":
            case "price_total_after_disc":
                if (entity.service_type === VAM2types.EvServiceType.default) {
                    if (this.store.isEntityNew(entity)) {
                        node.innerHTML = "<i>" + this.translate("EvBookingditor_ToCalculate") + "</i>";
                    }
                    else {
                        if (!entity.ref_pricelist && !entity.is_oversteered_price) this.UiModder.domClass.add(node, "warningBG");

                        if (typeof (value) == "string" && value != "") {
                            node.innerHTML = parseFloat(value).toFixed(2) + " €";
                            return true;
                        } else if (typeof (value) == "number") {
                            node.innerHTML = value.toFixed(2) + " €";
                            return true;
                        }
                        return false;
                    }
                } else {

                    node.innerHTML = "";// entity.$service_type;
                    //this.disableNode(cell.tableCellNode, true);
                }
                return true;
                break;
            case "is_option":
                if (entity.service_type != VAM2types.EvServiceType.default) {
                    //this.disableNode(cell.tableCellNode, true);
                    node.innerHTML = "";
                    return true;
                }
                break;
            case "is_cancelled":
                let checkBox = this.canceledCheckBoxRegistry[entity.ID];
                if (!checkBox) {
                    checkBox = new CheckBox();
                    checkBox.setValue(entity.is_cancelled, true);
                    if (!entity.is_finished && this.hasUserRole("Service_Edit")) {
                        checkBox.on("change", lang.hitch(this, this._onChangeCanceled, entity));
                    } else {
                        this.disableNode(checkBox, true);
                    }
                    this.canceledCheckBoxRegistry[entity.ID] = checkBox;
                }
                node.innerHTML = "";
                checkBox.placeAt(node);
                return true;
                break;
            case "discount":
                if (entity.service_type === VAM2types.EvServiceType.default) {
                    node.innerHTML = `${value ? value : 0} %`;
                } else {
                    node.innerHTML = "";
                    //this.disableNode(cell.tableCellNode, true);
                }

                return true;
                break;
        }

        /*


         **/


        return false;
    }




    private _checkEnableCancel(entity: VAM2types.EvServiceBooking) {
        //console.debug(this.id + "_checkEnableCancel", entity);
        if (this.store.isEntityExisting(entity) && entity?.documents?.length > 0 && entity.is_cancelled != true && !entity.is_finished) return true;

        return false;
    }
    private _checkEnableDelete(entity: VAM2types.EvServiceBooking) {
        //console.debug(this.id + "_checkEnableCancel", entity);
        if (entity.documents?.length > 0 || entity.is_finished) return false;
        return true;
    } private _checkEnableExtendedEdit(entity: VAM2types.EvServiceBooking) {
        //console.debug(this.id + " _checkEnableEdit", entity);
        return this.store.isEntityExisting(entity) && !this.store.isEntityChanged(entity) && !entity.is_finished;
    }
    private _onClick_CancelService(rowGrp: StaticTable.StaticTableRowGroup<VAM2types.EvServiceBooking>) {

        //console.debug("cancel", cell.entity);
        if (rowGrp.entity) {
            rowGrp.entity.is_cancelled = true;
            this.store.changeEntry(rowGrp.entity);
        }
    }

    private _afterDeleteEntry(rowGrp: StaticTable.StaticTableRowGroup<VAM2types.EvServiceBooking>) {
    }

    private _onClickOpenEvServiceBooking(rowgroup: StaticTable.StaticTableRowGroup<VAM2types.EvServiceBooking>) {

    }

    private _onClick_Calculation(rowgroup: StaticTable.StaticTableRowGroup<VAM2types.EvServiceBooking>) {
        //console.debug(rowgroup.entity);
        let entity = rowgroup.entity;

        let entityview = new GenericEntityView();
        //entityview.addAdditionalRequestParam();
        entityview.setup(entity.ID, entity.Classname, entity.description, "description", null, { "mode": "calculationEditor" }, "calculationEditor");

        entityview.on("change", lang.hitch(this, this.reloadEntity, entity.ID));

    }

    private reloadEntity(ID: string) {
        this.store.loadEntityFromDatabase(ID, VAMclassNames.pos_ev_serv);
    }

    private _onClick_EditEvServiceBooking(rowgroup: StaticTable.StaticTableRowGroup<VAM2types.EvServiceBooking>) {
        //console.debug(rowgroup.entity);
        let entity = rowgroup.entity;

        let entityview = new GenericEntityView();
        //entityview.addAdditionalRequestParam();
        entityview.setup(entity.ID, entity.Classname, entity.description, "description", null, { "mode": "calculationEditor" }, "calculationEditor");

    }
    private _onChange_ServiceQuantity(entity: VAM2types.EvServiceBooking, value): void {

        entity.quantity_multiplier = value;

        this.store.changeEntry(entity, true);
    }

    private _emitHandle: any = null;
    private _onChange_StoreData() {

        let diffData = this.store.getDiffData(true);



        let completeList = this.store.getCurrentCompleteList();

        if (!this.table) {
            this.setupTable();
        }

        console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData, completeList);

        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", diffData), 100);
    }

    private _emitHandleCanceled: any = null;
    private _onChange_StoreDataCanceled() {
        let diffData = this.canceledServiceStore.getDiffData(true);


        let completeList = this.canceledServiceStore.getCurrentCompleteList();

        if (!this.canceledServiceTable) {
            this.setupTableCanceled();
        }

        console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData, completeList);

        if (this._emitHandleCanceled) {
            clearTimeout(this._emitHandleCanceled);
        }

        this._emitHandleCanceled = setTimeout(lang.hitch(this, this.emit, "changeCanceled", diffData), 100);
    }

    private _onChangeService(): void {
        let value = this.inputEvService.getValue() as VAM2types.EvService;

        this.addNewEntry(value);

        this.inputEvService.setValue(null, true);
    }

    private _sortingTimeout: any = null;
    private addNewEntry(serviceEntity: VAM2types.EvService) {
        if (serviceEntity != null) {

            let fakeEvServiceBooking: Partial<VAM2types.EvServiceBooking> = {
                ID: StringHelpers.randomID(16),
                serviceID: serviceEntity.ID,
                service_type: serviceEntity.service_type,
                $service_type: serviceEntity.$service_type,
                is_oversteered_price: false,
                is_option: false,
                quantity: serviceEntity.quantity,
                quantity_multiplier: serviceEntity.quantity_multiplier ? serviceEntity.quantity_multiplier : 1,

                description: serviceEntity.description,
                service_original_description: serviceEntity.description,
                unitCode: serviceEntity.unitCode,
                order: 0,//this.store.getCurrentCompleteList().length + 1,
                orderService: serviceEntity.order,
                orderCategory: serviceEntity.orderCategory,
                createEvTaskBeyond: serviceEntity.createEvTaskBeyond,
            }

            // prüfen ob es eine Paketzuweisung ist, weil dort noch einige weitere Übersteuerungen/Vorgabewerte für die Leistungsbuchung drinstehen können!
            let pack = serviceEntity as any as VAM2types.EvServicePackEntry_Aliased;
            if (pack.servicePackAssignmentID) {
                fakeEvServiceBooking.is_option = pack.is_option;
            }

            if (this.store.isEntityExisting(fakeEvServiceBooking as any, "serviceID", true)) {
                let existingEntity = this.store.getEntityById(fakeEvServiceBooking.serviceID, "serviceID");

                existingEntity.quantity_multiplier += fakeEvServiceBooking.quantity_multiplier;

                this.store.changeEntry(existingEntity);
            }
            else {
                this.store.addEntry(fakeEvServiceBooking as any, "new");
            }

            if (serviceEntity.childService && this.hasFeature("EvBooking/EvServiceConfigPanel")) this.addNewEntry(serviceEntity.childService);

            /* also das muss weg. von außerhalb mit eigenem Timeout eine Sortinfunktion IN der Table aufrufen ist nicht gut
            entweder Table kümmer sich selber drum mit ihrer Sorting-Config oder wir kümmern uns von außerhalb um die Sortierung bevor die Table
            die Daten bekommt */
        //    if (this._sortingTimeout) {
        //        clearTimeout(this._sortingTimeout);
        //    }
        //    this._sortingTimeout = setTimeout(lang.hitch(this.table, this.table.runAdditionalSorting), 150);
        }
    }


    setRoomId(value: string): void {

        this.roomId = value;

        this.inputEvService.addRequestProperty("roomID", this.roomId);

        this.inputEvService.addAdditionalRequestParameter("roomID", this.roomId);

    }

    getData() {
        return this.store.getCurrentCompleteList();
    }
    getDataCanceled() {
        return this.canceledServiceStore.getCurrentCompleteList();
    }

    getDiffData() {
        let diffData = this.store.getDiffData();
        return diffData;
    }
    getDiffDataCanceled() {
        let diffData = this.canceledServiceStore.getDiffData();
        return diffData;
    }


    private _onPrivilegeLoaded(role: string, hasPriv: boolean) {
        if (hasPriv) {
            switch (role) {
                case "Service_Edit":

                    this.table.setAdditionalSortingConfig({ ascending: true, sortingAttributeNames: ["orderCategory", "orderService"] });
                    //An sich macht das Sortieren meiner Meinung nach keinen Sinn in dieser Liste. Die Stornierten Leistungen werden hier nicht mit berücksichtigt und dadruch wird ja die Order nie richtig sein
                    if (this.hasFeature("EvBooking/SortServiceBookingList")) this.table.setupRowSorting("order");//, lang.hitch(this, this._onRowSorting));
                    //this.table.addDefaultRowActionButton("edit", lang.hitch(this, this._onClick_EditEvServiceBooking), lang.hitch(this, this._checkEnableEdit));

                    this.table.addCustomRowActionButton("editCalculation", lang.hitch(this, this._onClick_Calculation), "fas fa-edit", "", 120, "", lang.hitch(this, this._checkEnableExtendedEdit), true);
                    this.table.addCustomRowActionButton("cancelService", lang.hitch(this, this._onClick_CancelService), "fas fa-ban", "", 120, "", lang.hitch(this, this._checkEnableCancel), true);
                    break;

                case "Service_Delete":
                    this.table.addDefaultRowActionButton("delete", lang.hitch(this, this._afterDeleteEntry), lang.hitch(this, this._checkEnableDelete), true);

                    break;
            }
        }
    }

    private _onClick_RowResources(rowgrp: StaticTable.StaticTableRowGroup<VAM2types.EvServiceBooking>) {

    }

    private _onCheckResourceButton(entity: VAM2types.EvServiceBooking, rowgrp: StaticTable.StaticTableRowGroup<VAM2types.EvServiceBooking>): boolean {

        if (entity.EL_resource_booking_1_vt_pos_ev_serv?.length) {
            return true;
        }

        return false;
    }

    private resourceTablesRegistry: Record<string, resourceTableRegistryEntry>
    private resourceChecker: EvService_ResourceLoadCheck;
    private _checkResources() {

        if (!this.evBooking) return;

        // einmalig aus bestehenden Daten aufsetzen:
        let existingList = this.store.getCurrentCompleteList("existing");
        let addedList = this.store.getCurrentCompleteList("new");

        let requestData: EvService_ResourceLoadCheckRequestData = {
            dateStart: this.evBooking.date_start,
            dateEnd: this.evBooking.date_end,
            evServiceBookings: [],
            evServices: []
        };

        for (let entity of existingList) {
            requestData.evServiceBookings.push({
                amount: entity.quantity_multiplier,
                serviceBookingID: entity.ID
            });
        }

        for (let entity of addedList) {
            requestData.evServices.push({
                amount: entity.quantity_multiplier,
                serviceID: entity.serviceID
            });
        }

        this.resourceChecker.executeCheck(requestData, lang.hitch(this, this._onResourceCheckResult));
    }

    private _registerResourceTableForEntity(serviceBooking: VAM2types.EvServiceBooking): resourceTableRegistryEntry {
        let innerTable = new EvService_ResourceLoadTable();
        this.table.setRowGroupExpanderContent(serviceBooking, innerTable.domNode);
        this.resourceTablesRegistry[serviceBooking.serviceID] = { table: innerTable, isOverload: false };
        let reg = this.resourceTablesRegistry[serviceBooking.serviceID];

        return reg;
    }
    private _onResourceCheckResult(results: Array<VAM2types.ResourceLoadCheckResultData>) {
        for (let resultData of results) {
            let storeEntity = this.store.getEntityById(resultData.serviceID, "serviceID");

            if (storeEntity) {
                let reg = this.resourceTablesRegistry[resultData.serviceID];
                if (!reg && !!resultData.resources.length) {
                    reg = this._registerResourceTableForEntity(storeEntity);
                }

                if (reg) {
                    reg.table.setData(resultData.resources, storeEntity, this.evBooking);
                    reg.isOverload = false;
                    if (reg.table.isOverloaded()) {
                        reg.isOverload = true;
                        this.table.expandRow(storeEntity);
                    }
                }
            }
        }

        this._emitResourceOverload();
    }

    private _emitResourceOverload() {
        let count = 0;
        for (let key in this.resourceTablesRegistry) {
            count++;
            let reg = this.resourceTablesRegistry[key];
            if (reg.isOverload) {
                if (this.store.isEntityExisting(key,"serviceID", true, false)) {
                    this.emit("resourceOverload", true);
                    return;
                }
            }
        }

        if (count == 0) return;

        this.emit("resourceOverload", false);
    }

    private _onClick_Cell(cell: StaticTable.StaticTableCell<VAM2types.EvServiceBooking>) {
        this.table.expandRow(cell.tableRow.rowGroup.rowIndex, true);
    }

    private setupTable(): void {

        this.tableContainer.innerHTML = null;

        this.hideNode(this.reloadContainer, !this.evBooking?.ID);

        this.table = new StaticTable();
        this.table.setVerticalAlign("middle");



        this.hasUserRole("Service_Edit", lang.hitch(this, this._onPrivilegeLoaded, "Service_Edit"), this.evBooking);
        this.hasUserRole("Service_Delete", lang.hitch(this, this._onPrivilegeLoaded, "Service_Delete"), this.evBooking);

        if (FeatureHelpers.hasFeature("EvService/PhysicalResources")) {
            this.resourceTablesRegistry = {};
            this.resourceChecker = new EvService_ResourceLoadCheck();
            //this.table.addCustomRowActionButton("resources", lang.hitch(this, this._onClick_RowResources), "fas fa-chair", "Ressourcen", 500, "Ress", lang.hitch(this, this._onCheckResourceButton), true);
            //this.table.setupExpandableRows({
            //    //expanderSetupCallback: lang.hitch(this, this._onRowExpanderSetup),
            //    expanderClickCallback: lang.hitch(this, this._onRowExpand),
            //    entityChangeCallback: lang.hitch(this, this._onRowExpanderEntityUpdate),
            //    tableRedrawCallback: lang.hitch(this, this._onTableRedraw)
            //});
            this.store.on("change", lang.hitch(this, this._checkResources));

            this._checkResources();
        }

        //this.table.setRowClick(lang.hitch(this, this._onClickOpenEvServiceBooking));

        this.table.setFormatter(lang.hitch(this, this.table_formatterFunction));
        

         //, lang.hitch(this, this._onRowDeleting));
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);

        this.table.addLineConfig(this.tableLayout);
        


        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);
        

        //this.table.setData(this.entitylist);
        this._emptyOptionRegistry();

        this.table.setupFromStore(this.store);

        this.table.setCyAttribute("evServingBookingList");
        
    }

    private setupTableCanceled() {

        this.canceledServiceContainer.innerHTML = null;

        this.hideNode(this.reloadContainer, !this.evBooking?.ID);

        this.canceledServiceTable = new StaticTable();
        this.canceledServiceTable.setVerticalAlign("middle");
        this.canceledServiceTable.setFormatter(lang.hitch(this, this.canceledServiceBookingsTable_formatterFunction));
        this.canceledServiceTable.addLineConfig(this.canceledServiceBookingsTableLayout);
        this.UiModder.domConstruct.place(this.canceledServiceTable.domNode, this.canceledServiceContainer);
        this._emptyCanceledRegistry();

        this.canceledServiceTable.setupFromStore(this.canceledServiceStore);
        this.table.setCyAttribute("evServingBookingCanceledService");
    }

    private _onClick_reloadData(evt) {
        this.loadList();
    }

    private _emptyOptionRegistry() {
        let keys = Object.keys(this.optionCheckBoxRegistry);
        for (let key of keys) {
            this.optionCheckBoxRegistry[key]?.destroy();
        }
        this.optionCheckBoxRegistry = {};
    }

    private _emptyCanceledRegistry() {
        let keys = Object.keys(this.canceledCheckBoxRegistry);
        for (let key of keys) {
            this.canceledCheckBoxRegistry[key]?.destroy();
        }
        this.canceledCheckBoxRegistry = {};
    }

    private loadList() {
        if (!this.evBooking) return;
           

        this.StandbyStart();

        let data = {
            "bookingID": this.evBooking?.ID
        };

        this.RequestManager.callfunction(
            "Webtool_API_EvBooking__GetEvServiceBookingsV2",
            data,
            lang.hitch(this, this._onLoadListResponse),
            lang.hitch(this, this._onLoadListError)
        );
    }

    private _onLoadListResponse(response: { active: Array<VAM2types.EvServiceBooking>, canceled: Array<VAM2types.EvServiceBooking> }) {
        this.StandbyStop();

        this._emptyOptionRegistry();
        this._emptyCanceledRegistry();

        this.store.setup(response?.active);
        this.canceledServiceStore.setup(response?.canceled);

        this._onChange_StoreData();
        this._onChange_StoreDataCanceled();
    }

    private _onLoadListError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error);
    }

     private _onClick_OpenEvServicesSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvServices",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            this.inputEvService.getAdditionalRequestParams(true)
         );

    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<VAM2types.EvService>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;
        if (mode == "selectEvServices") {
            let newServiceList = [];

            for (let item of items) {

                let entity: Partial<VAM2types.EvService> = item.entry?.data;

                if (!entity) {
                    entity = {
                        ID: item.entry.value, description: item.entry.label
                    };
                }
                else {
                    if (entity.Classname == VAMclassNames.service_pack_ev_serv) {
                        let pack = entity as VAM2types.EvServicePack;
                        debugger;
                        for (let service of pack.service) {
                            this.addNewEntry(service as any);
                        }

                        return;
                    }
                }

                if (this.hasFeature("EvBooking/EvServiceConfigPanel")) newServiceList.push(entity);
                else this.addNewEntry(entity as any);
            }
            if (this.hasFeature("EvBooking/EvServiceConfigPanel")) {
                let configPanel = new EvServiceConfigPanel();
                configPanel.on("confirmed", lang.hitch(this, this._onConfigPanelConfirmed));
                configPanel.setup(newServiceList);
            }
        }
        //this.previousSEDvalue = items;
    }

    _onConfigPanelConfirmed(servicelist: Array<VAM2types.EvService>) {
        for (let service of servicelist) {
            this.addNewEntry(service);
        }
    }



    setup(data: { active: Array<VAM2types.EvServiceBooking>, canceled: Array<VAM2types.EvServiceBooking> }, evBooking: VAM2types.EvBooking_Base) {



        this.evBooking = evBooking;

        this.store.setup(data.active, "ID");
        this.canceledServiceStore.setup(data.canceled, "ID");

        this.setupTable();
        this.setupTableCanceled();

    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        this.canceledServiceStore = new EntityStore();
        this.canceledServiceStore.on("change", lang.hitch(this, this._onChange_StoreDataCanceled));

        let module: { customTableLayouts: Array<{ id: string } & StaticTable.RowConfig> } = this.getModule("EvBooking");
        if (module?.customTableLayouts?.length) {

            for (let layout of module.customTableLayouts) {
                try {
                    if (layout.id == "ServiceBookingTable") {
                        this.tableLayout.attributes = layout.attributes;
                        this.tableLayout.colNamesInternal = layout.colNamesInternal;
                        this.tableLayout.colspans = layout.colspans;
                        this.tableLayout.headings = layout.headings;
                        this.tableLayout.widths = layout.widths;
                        this.tableLayout.alignmentsHeading = layout.alignmentsHeading;
                        this.tableLayout.alignmentsRow = layout.alignmentsRow;
                    }
                    if (layout.id == "CanceledServiceBookingTable") {
                        this.canceledServiceBookingsTableLayout.attributes = layout.attributes;
                        this.canceledServiceBookingsTableLayout.colNamesInternal = layout.colNamesInternal;
                        this.canceledServiceBookingsTableLayout.colspans = layout.colspans;
                        this.canceledServiceBookingsTableLayout.headings = layout.headings;
                        this.canceledServiceBookingsTableLayout.widths = layout.widths;
                        this.canceledServiceBookingsTableLayout.alignmentsHeading = layout.alignmentsHeading;
                        this.canceledServiceBookingsTableLayout.alignmentsRow = layout.alignmentsRow;
                    }
                } catch (ex) {
                    console.warn("invalid table layout in appsettings?", layout, module)
                }
            }
        }

        this.hideNode(this.sectionAddEntry, !this.hasUserRole("Service_Create"));
        this.inputEvService.setLabelAttribute("description", "$service_type");
        this.inputEvService.addInlineButton(lang.hitch(this, this._onClick_OpenEvServicesSED));

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvServiceBookingList);
